/** Canonical label for “shade matches the product photo” (admin + new products). */
export const DEFAULT_COLOR_LABEL = 'As image';

/** Stored on older products before the rename. */
export const LEGACY_DEFAULT_COLOR_LABEL = 'Default color';

export function isDefaultColorLabel(c) {
  return c === DEFAULT_COLOR_LABEL || c === LEGACY_DEFAULT_COLOR_LABEL;
}

/** True for As image / Default color / backend `default` — not a shopper-facing swatch. */
export function isDefaultColorPlaceholder(color) {
  if (color == null) return false;
  const name =
    typeof color === 'string'
      ? color.trim()
      : String(color?.name || color?.value || color?.color || color).trim();
  if (!name) return false;
  if (isDefaultColorLabel(name)) return true;
  return name.toLowerCase() === 'default';
}
